import { lazyLoad } from '../../index'

export default {
  path: 'customers',
  component: lazyLoad('Admin/Business/Customer/layout')
}
